// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Rede_ImportacaoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * POST /rede/importar — a planilha "Base de Unidades" lida no navegador (Full). aplicar=false é o
 * ensaio: devolve o plano sem gravar nada; aplicar=true grava o mesmo plano.
 */
import type { Rede_ImportacaoRetornoRow } from './Rede_ImportacaoRetornoRow'
import type { Rede_ImportacaoUnidadeRow } from './Rede_ImportacaoUnidadeRow'
import { registerContract } from './validate'

export interface Rede_ImportacaoInput {
aplicar?: boolean
unidades?: Rede_ImportacaoUnidadeRow[]
retornos?: Rede_ImportacaoRetornoRow[]
}

registerContract('Rede_ImportacaoInput', {
  aplicar:  { type: 'boolean', required: false },
  unidades: {
    type: 'array',
    required: false,
    items: {
      linha:                  { type: 'number',  required: false },
      numero:                 { type: 'string',  required: false },
      status:                 { type: 'string',  required: false },
      unidade:                { type: 'string',  required: false },
      pais:                   { type: 'string',  required: false },
      uf:                     { type: 'string',  required: false },
      inauguracao:            { type: 'string',  required: false },
      cnpj:                   { type: 'string',  required: false },
      cidade:                 { type: 'string',  required: false },
      pasta:                  { type: 'string',  required: false },
      razao_social:           { type: 'string',  required: false },
      inclusao_pj:            { type: 'string',  required: false },
      area_atuacao:           { type: 'string',  required: false },
      endereco:               { type: 'string',  required: false },
      endereco_numero:        { type: 'string',  required: false },
      complemento:            { type: 'string',  required: false },
      bairro:                 { type: 'string',  required: false },
      uf_endereco:            { type: 'string',  required: false },
      pais_endereco:          { type: 'string',  required: false },
      cep:                    { type: 'string',  required: false },
      telefone:               { type: 'string',  required: false },
      telefone_atendimento:   { type: 'string',  required: false },
      email_empresa:          { type: 'string',  required: false },
      redes_sociais:          { type: 'string',  required: false },
      gmn:                    { type: 'string',  required: false },
      site:                   { type: 'string',  required: false },
      treinador:              { type: 'string',  required: false },
      contrato_codigo:        { type: 'string',  required: false },
      contrato_data:          { type: 'string',  required: false },
      vigencia:               { type: 'string',  required: false },
      historico_contratos:    { type: 'string',  required: false },
      inclusao_factory:       { type: 'string',  required: false },
      documentos_pendentes:   { type: 'string',  required: false },
      pendencias_inauguracao: { type: 'string',  required: false },
      observacoes:            { type: 'string',  required: false },
      pontos_a_conferir:      { type: 'string',  required: false },
      socios:                 { type: 'string',  required: false },
      cpfs:                   { type: 'string',  required: false },
      nascimentos:            { type: 'string',  required: false },
    },
  },
  retornos: {
    type: 'array',
    required: false,
    items: {
      linha:            { type: 'number',  required: false },
      unidade:          { type: 'string',  required: false },
      distrato:         { type: 'string',  required: false },
      linha_telefonica: { type: 'string',  required: false },
      backup_whatsapp:  { type: 'string',  required: false },
      maquinario:       { type: 'string',  required: false },
      bens_uniformes:   { type: 'string',  required: false },
      observacao:       { type: 'string',  required: false },
      exclusao_site:    { type: 'string',  required: false },
      conferencia:      { type: 'string',  required: false },
      juridico:         { type: 'boolean', required: false },
    },
  },
})
